export const navigateToParent = (navigate, location) => {
  const items = location.pathname.split("/").filter((e) => e.length > 1);
  !location.pathname.includes("coefx")
    ? navigate(-1)
    : navigate("/".concat(items.slice(0, 3).join("/")));
};

export const navigateView = (id, navigate, location, subpath = null) => {
  const items = location.pathname.split("/").filter((e) => e.length > 0);
  navigate(
    "/"
      .concat(items.slice(0, items.length).join("/"))
      .concat(`/${subpath ? subpath + "/" : ""}${id}`)
  );
};

export const navigateEdit = (id, navigate, location, subpath = null) => {
  navigate(
    "/".concat(
      location.pathname
        .split("/")
        .filter((e) => e.length > 0)
        .join("/")
        .concat(`/${subpath ? subpath : ""}`)
        .concat(`${subpath ? "/edit" : "edit"}/${id}`)
    )
  );
};

// Tag inputs of the admin forms hold [{ label, value }] while the API stores
// plain ids. An id the option list cannot resolve keeps its raw value as label
// instead of being dropped, so saving a row never silently loses a link.
export const optionsFromIds = ({ ids, options }) => {
  const optionByValue = new Map(
    (options || []).map((option) => [option.value, option])
  );
  return (ids || []).map(
    (id) => optionByValue.get(id) ?? { label: String(id), value: id }
  );
};

export const joinOptionLabels = (options, separator = ", ") =>
  (options || []).map((option) => option.label).join(separator);

export const statusTypes = [
  { name: "", value: null },
  { name: "true", value: true },
  { name: "false", value: false },
];

export const tagList = [
  { name: "", value: "" },
  { name: "TAG_STR_WBOOK_OTHER", value: "TAG_STR_WBOOK_OTHER" },
  {
    name: "TAG_STR_WBOOK_RHA_TSI_ILYON",
    value: "TAG_STR_WBOOK_RHA_TSI_ILYON",
  },
  { name: "TAG_DAV_EMPL_CERT", value: "TAG_DAV_EMPL_CERT" },
  { name: "TAG_DAV_INS_CERT", value: "TAG_DAV_INS_CERT" },
  { name: "TAG_DAV_WLC_LETTER", value: "TAG_DAV_WLC_LETTER" },
  { name: "TAG_DAV_TEST_PERIOD", value: "TAG_DAV_TEST_PERIOD" },
  { name: "TAG_DAV_NON_COMP", value: "TAG_DAV_NON_COMP" },
  { name: "TAG_MISSION_ORDER", value: "TAG_MISSION_ORDER" },
  { name: "TAG_SERVICE_CONTRACT", value: "TAG_SERVICE_CONTRACT" },
  { name: "TAG_BANK_ACCOUNT_OP", value: "TAG_BANK_ACCOUNT_OP" },
  { name: "TAG_INSURANCE_FR", value: "TAG_INSURANCE_FR" },
  { name: "TAG_INSURANCE_COLORZ", value: "TAG_INSURANCE_COLORZ" },
  { name: "TAG_MISSION_ESTIMATE", value: "TAG_MISSION_ESTIMATE" },
];

export const handleUpload = (
  payload,
  navigate,
  location,
  uploadExchangeRate
) => {
  const defaultCountryId = 1;
  const countryId = Number(payload?.country_id) || defaultCountryId;
  const file = payload.file.target.files[0];
  const isCsvFile = file?.type === "text/csv";
  if (isCsvFile && countryId) {
    uploadExchangeRate(countryId, file);
    navigateToParent(navigate, location);
  } else if (!isCsvFile) {
    console.error("Only CSV file accepted");
  } else if (!countryId) console.error("Country missing");
};
